export default {
  title: {
    id: 'sav_platform_issues',
    defaultMessage: 'Problems',
  },
  repairType: {
    id: 'asp_conversation_details_events_repair_type',
    defaultMessage: 'Repair',
  },
  noEventDescription: {
    id: 'bo_sellers_customer_care_request_details_events_no_event_description',
    defaultMessage: 'None',
  },
  noEventBody: {
    id: 'bo_sellers_customer_care_request_details_events_no_event_text',
    defaultMessage: 'No customer problems exist for this order.',
  },
  errorDescription: {
    id: 'bo_sellers_customer_care_request_details_events_description_error',
    defaultMessage: 'Couldn’t load customer problems',
  },
}
